module.exports = __webpack_public_path__ + "static/media/城市配送_09.30e114d1.jpg";